import React from "react";

const CancelButton = ({ onToggle }) => (
  <button id="x" onClick={onToggle}>
    <div />
    <div />
  </button>
);

export default CancelButton;



// WEBPACK FOOTER //
// ./src/components/Navigation/CancelButton.jsx